import axios from 'axios'
import {
  RES_OK,
  CHANNEL_ID,
  RES_SESSION_EXPIRED,
  OVERLORD_AGENT_API_LIST
} from '@/config'
import { Message } from 'element-ui'
import store from '@/store'
//   import { getToken } from '@/utils/auth'
import md5 from 'js-md5'
import router from '@/router'
class HttpRequest {
  constructor(baseURL) {
    this.baseURL = baseURL
  }
  getInsideConfig() {
    const config = {
      baseURL: this.baseURL,
      headers: {
        //  'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      method: 'post'
    }
    return config
  }
  isObj(key) {
    return typeof key === 'object'
  }
  //  整理请求数据
  arrangeParams(data, url) {
    const timestamp = new Date().getTime()
    //  * Sign 签名(接口请求参数 + 时间戳 + key)进行MD5加密，key值使用登陆返回的Uid值
    data.ClientId = CHANNEL_ID
    data.Timestamp = timestamp
    const state = store.state || {}
    const userInfo = state.userInfo || {}
    const companyInfo = state.companyInfo || {}
    if (userInfo.id) {
      if (data.Params) {
        data.Params.operateId = userInfo.id
        data.Params.operateName = userInfo.username
        data.Params.COMPANY_ID = companyInfo.id //  分表查询用的——当前被操作的公司id
        // data.Params.COMPANY_ID = userInfo.companyId //  分表查询用的
      }
      if (userInfo.isOverlordPosAgent === '1') {
        if (OVERLORD_AGENT_API_LIST.some(info => info === url)) {
          data.Params.posAgentStaffId = userInfo.id
        }
      }
      data.OperateId = userInfo.id
      data.Token = state.sysToken
      const temp = JSON.stringify(data.Params)
      const sign = md5(
        temp + timestamp + CHANNEL_ID + state.sysUid
      ).toLowerCase()
      data.Sign = sign
    }
    const array = []
    for (const key in data) {
      const keyVal = data[key]
      if (!this.isObj(keyVal)) {
        array.push(`${key}=${keyVal}`)
      } else {
        array.push(`${key}=${encodeURIComponent(JSON.stringify(keyVal))}`)
      }
    }
    return array.join('&')
  }

  arrangeRequest(instance, url) {
    //  请求拦截器
    instance.interceptors.request.use(
      config => {
        return config
      },
      error => {
        console.log(error) //  for debug
        return Promise.reject(error)
      }
    )
    //  响应拦截器
    instance.interceptors.response.use(response => {
      const { data } = response
      if (data.Code === RES_OK) {
        return data
      } else if (data.Code === RES_SESSION_EXPIRED) {
        //  需要重新登录
        Message({
          message: data.Message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        // return data
        store.state.isLogin = false
        sessionStorage.clear()
        router.push({
          name: 'Login'
        })
        return false
      } else if (
        data.Code === -10010 ||
        data.Code === -10030 ||
        data.Code === -10040
      ) {
        // 商品和券关联活动需要删除时使用
        return data
      } else if (data.Code === -10000 && url === 'ylyAddPrinter') {
        // debugger
        return data
      } else if (data.Code === -10000 && url === 'ylyGetPrintStatus') {
        // debugger
        return data
      } else {
        //  其他正常错误提示
        Message({
          message: data.Message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
        return data
      }
    })
  }

  request(options) {
    const data = options.data || {}
    const params = this.arrangeParams(data, data.Api)
    options.data = params
    const instance = axios.create()
    //  console.log(params)
    options = Object.assign(this.getInsideConfig(), options)
    this.arrangeRequest(instance, data.Api)
    // this.arrangeRequest(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
